<template>
  <section>
    <div class="jifen">
      <div class="user-main">
        <div class="user-cont layui-card">
          <div class="layui-card-header layui-card-header-auto">
            <div class="utab clearfix">
              <ul class="clearlist clearfix fl">
                <li :class="nowStatus==''?'active':''" @click="changeTab('')">
                  <a href="javascript:;">我的积分</a>
                </li>
                <li :class="nowStatus=='0'?'active':''" @click="changeTab('0')">
                  <a href="javascript:;">积分明细</a>
                </li>
              </ul>
            </div>
            <div class="jifentongji flex">
              <div class="wyjifen">
                <p>我的积分</p>
                <span class="iconfont icon-gold color-primary"></span>
                <p class="num">{{balanceLog.balance}}</p>
              </div>
              <div class="jifenmingxi">
                <div class="title">最近三个月积分统计</div>
                <div class="jifentype flex ju-be">
                  <li>
                    <span class="type">总入账</span>
                    <div class>
                      <span>+</span>
                      <span class="num">{{balanceLog.income}}</span>
                    </div>
                  </li>
                  <li>
                    <span class="type">总支出</span>
                    <div class>
                      <span>+</span>
                      <span class="num">{{balanceLog.outcome}}</span>
                    </div>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="nowStatus">
        <el-table :data="balanceLog.list.data" height="250" style="width: 100%">
          <el-table-column prop="addtime" label="最近3个月"></el-table-column>
          <el-table-column prop="amount" label="数量"></el-table-column>
          <el-table-column prop="classfy" label="类型"></el-table-column>
          <el-table-column prop="remark1" label="详细说明"></el-table-column>
        </el-table>
        <el-pagination
          class="fenye"
          background
          layout="prev, pager, next"
          :page-size="balanceLog.list.per_page"
          @current-change="currentPage"
          :total="balanceLog.list.total"
        ></el-pagination>
      </div>
      <div v-else>
        <div style="width:100%;height:30px;background:#f5f5f5"></div>
        <div class="jifenSC">
          <div class="active">积分商城</div>
          <div class="jifenList flex">
          
            <a  class="jifenItem" v-for="(item) in goodsList.data" :key="item.id" :href="'#/jifengoods_detail?id='+item.id" target="_blank" >
              <img :src="item.indexpic" alt='积分商品图片' srcset class="goodsimg" />
              <div class="goodsInfo">
                <div class="name ellipsis">{{item.title}}</div>
                <div class="duihuan flex ju-be">
                  <div class="num">
                    <span class>{{item.price}}积分</span>
                    <!-- <span class="yuanjia">￥{{item.price1}}</span> -->
                  </div>
                  <button class type="primary">立即兑换</button>
                </div>
              </div>
            </a>
          </div>
          <el-pagination
          class="fenye"
          background
          layout="prev, pager, next"
          :page-size="goodsList.per_page"
          @current-change="currentPagegoods"
          :total="goodsList.total"
        ></el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Coupons",
  data() {
    return {
      balanceLog: {},
      nowStatus: "",
      goodsList:{},
      // $data:{
      page: 1,
      goodspage: 1,
      type: "account2",
      start: "",
      end: "",
      // },
      guid: sessionStorage.guid,
      orderstatus: [{ 0: "我的积分" }, { 1: "积分明细" }]
    };
  },
  props: {},
  methods: {
    // search() {
    //   this.getOrderList();
    // },
    // 改变tab
    changeTab(type) {
      console.log(type);
      this.nowStatus = type;
      // this.getbalance();
    },
    // 获取积分商品列表
    async getJifengoods() {
      let goodsList = await await this.$fetch("shop/giftlist", {
        body: {
          page: this.goodspage
        }
      });
      console.log("积分商品列表",goodsList)
      this.goodsList=goodsList;
    },
    // 改变当前页
    currentPage(e) {
      this.page = e;
      this.getbalance();
    },
    currentPagegoods(e){
       this.goodspage = e;
      this.getJifengoods();
    },
    async getbalance() {
      let res = await await this.$fetch("member/balance", {
        body: {
          page: this.page,
          type: this.type,
          start: this.start,
          end: this.end
        }
      });
      let arr = res.list.data;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].type == 1) {
          arr[i].amount = "+" + arr[i].amount;
        } else {
          arr[i].amount = "-" + arr[i].amount;
        }
        for(let key in res.typelist){
          if(arr[i].typeid==key){
             arr[i]['classfy']=res.typelist[key]
          }
        }
      }
      res.list.data = arr;
      this.balanceLog = res;
    }
  },
  mounted() {
    this.getbalance();
    this.getJifengoods();
  }
};
</script>
<style lang='scss' scoped>
.jifentongji {
  font-size: 20px;
  font-size: 20px;
  align-items: flex-start;
  justify-content: space-around;
  .wyjifen {
    width: 100px;
    .icon-gold {
      font-size: 50px;
    }
    .num {
      font-size: 30px;
      margin: 0;
      font-weight: normal;
    }
  }
  .jifenmingxi {
    width: 450px;
    margin-top: 15px;
    font-size: 16px;
    font-weight: bold;
    .jifentype {
      width: 100%;
      margin-top: 30px;
      .type {
        font-size: 12px;
      }
      .num {
        font-size: 30px;
        font-weight: normal;
      }
    }
  }
}
.jifenSC {
  padding: 20px;
  box-sizing: border-box;
  .active {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    display: inline-block;
    color: rgba(243, 153, 10, 1);
    border-bottom: 2px solid #f3990a;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jifen.vue